module.exports = __webpack_public_path__ + "img/university_logo.72223616.jpg";